// Account Registration module

define('modules/Product/Product360ViewService',[
    'jquery',
    'global/all'
], function ($, Roc) {
    'use strict';

    var apiUrl = window.RocConfig.api.baseRocApiUrl;

    function get360Images(productId) {
        return $.ajax({
            url: apiUrl + '/api/product360/' + productId,
            type: 'GET',
            contentType: 'application/json'
        });
    }

    var Product360ViewService = {
        get360Images: get360Images
    };

    Roc.Logger.debug('Product360ViewService.js Loaded:', Product360ViewService);

    return Product360ViewService;
});
